module.exports = __webpack_public_path__ + "img/gift8.8e86fc0b.png";